import { LoyaltyMember, LoyaltyTier } from '@rdss/client'

/**
 * Transforms the loyalty member data from the API to the format used in the storefront.
 */
export const transformLoyaltyMember = ({
    membershipId,
    referralCode,
    enrollmentDate,
    tier,
    currencies,
    pendingPoints,
}) => {
    const transformedTiers = {
        name: tier.name.toLowerCase(),
        expirationDate: tier.expirationDate,
        effectiveDate: tier.effectiveDate,
        qualifyingPointsNeededForNextTier: tier.qualifyingPointsNeededForNextTier,
    } as LoyaltyTier

    return {
        membershipId,
        referralCode,
        enrollmentDate,
        tier: transformedTiers,
        currencies,
        pendingPoints,
    } as LoyaltyMember
}